<template>
  <div>
    <b-container>
      <b-row class="mt-5">
        <b-col class="mt-5 text-danger">
          <h5>Es gab einen Fehler bei der Zahlungsabwicklung. <br />Bitte versuchen Sie es später erneut oder wenden Sie sich an Ihren Kundenbetreuer unter 0261 402-11111.</h5>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

import { ApiCalls } from '../scripts/ApiCalls'
export default {
  name: 'CallbackError',
  components: { },
  data () {
    return {
      custNo: [],
      state: [],
      msg: ''
    }
  },
  mounted () {
    let orderId = this.$route.query.orderid
    let merchantref = this.$route.query.merchantref
    let paymentmethod = this.$route.query.paymentmethod
    let pi = this.$route.query.pi
    ApiCalls.processCallback(orderId, merchantref, paymentmethod, pi, 'ERROR').then(res => {
      console.log(res)
    }).catch(error => {
      console.log(error)
    })
  },
  methods: {}
}
</script>

<style lang="css">

  .btn-evm-orange {
    background-color: rgb(243, 145, 0);
    border-color: rgb(243, 145, 0);
  }
</style>
